export const appMixin = {
  methods: {
    async getPublicIpAddress() {
      try {
        let publicIpResponse = await fetch('https://api.seeip.org/jsonip?');
        if (publicIpResponse) {
          publicIpResponse = await publicIpResponse.text();
          const {ip} = JSON.parse(publicIpResponse);
          return ip;
        }
      } catch (e) {
        console.warn(e);
        return null;
      }
      return null;
    },
  },
};

export default {appMixin};
